(() => {
const state = {};
const nameList = el => el.value.split(/\r?\n/).map(s=>s.trim()).filter(Boolean);
if(!customElements.get('jljb-bundle-options')) customElements.define('jljb-bundle-options',class extends HTMLElement {
connectedCallback(){
if(this.ready)return;this.ready=true;
this.querySelectorAll('select,textarea').forEach(el=>{if(state[el.name]!==undefined)el.value=state[el.name];});
this.addEventListener('input',()=>this.update());
this.addEventListener('change',()=>this.update());
this.update();
}
update(){
this.querySelectorAll('select,textarea').forEach(el=>state[el.name]=el.value);
const names=nameList(this.querySelector('textarea'));
const extra=Math.max(0,names.length-5);
this.querySelector('[data-name-count]').textContent=names.length;
this.querySelector('[data-name-cost]').textContent='$'+(extra*2).toFixed(2);
this.querySelector('[name="properties[Name count]"]').value=names.length;
this.querySelector('[name="properties[Additional names]"]').value=extra;
this.querySelector('textarea').setCustomValidity(names.length?'':'Please enter at least one name.');
}
});
document.addEventListener('submit',async event=>{
const form=event.target;
const options=form.querySelector('jljb-bundle-options');
if(!options)return;
event.preventDefault();event.stopImmediatePropagation();
options.update();
if(!form.reportValidity())return;
if(form.dataset.bundleBusy)return;
form.dataset.bundleBusy='true';
const error=options.querySelector('[data-bundle-error]');error.hidden=true;
const buttons=[...form.querySelectorAll('button[type="submit"],button[name="add"]')];
buttons.forEach(b=>b.disabled=true);
try{
const data=new FormData(form), properties={};
for(const [key,value] of data.entries()){const match=key.match(/^properties\[(.+)\]$/);if(match)properties[match[1]]=String(value);}
const qty=Number(data.get('quantity')||1);
const extra=Math.max(0,nameList(options.querySelector('textarea')).length-5);
const bundle=crypto.randomUUID();properties._bundle_group=bundle;
const items=[{id:Number(data.get('id')),quantity:qty,properties}];
if(extra)items.push({id:50623764037872,quantity:extra*qty,properties:{'For bundle':'Unbothered sweatshirt','Additional sleeve names':nameList(options.querySelector('textarea')).slice(5).join(', '),_bundle_group:bundle}});
const root=window.Shopify?.routes?.root||'/';
const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
if(!response.ok)throw new Error('Cart add failed');
window.location.assign(root+'cart');
}catch(e){error.hidden=false;buttons.forEach(b=>b.disabled=false);delete form.dataset.bundleBusy;}
},true);
})();